var map = {
	"./api.svg": "jkGI",
	"./asset.svg": "S8k9",
	"./branches.svg": "96nY",
	"./bug.svg": "SVqS",
	"./condition.svg": "tC6+",
	"./dashboard.svg": "BCGP",
	"./dd.svg": "BzSL",
	"./deploy.svg": "/ikf",
	"./dispatch.svg": "tVPt",
	"./enviroment.svg": "9zXf",
	"./execute.svg": "bYDC",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./funtest.svg": "N1mm",
	"./log.svg": "8uFK",
	"./machine.svg": "ocTq",
	"./message.svg": "G2zY",
	"./mock.svg": "5nc+",
	"./money.svg": "ig9B",
	"./name.svg": "m5Jr",
	"./paras.svg": "uLao",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./permission.svg": "j4kZ",
	"./pertest.svg": "15TM",
	"./plan.svg": "0Ex+",
	"./pr.svg": "vxZu",
	"./project.svg": "6CSd",
	"./report.svg": "2nwU",
	"./role.svg": "cqqK",
	"./rq.svg": "Ylhl",
	"./slaver.svg": "hajP",
	"./sprint.svg": "fogn",
	"./sys.svg": "zQA3",
	"./task.svg": "EK3d",
	"./testmanager.svg": "gp1I",
	"./wechat.svg": "pYJ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 77